"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createConfiguration = exports.createCasualConfiguration = exports.parseDate = exports.parse = exports.strict = exports.casual = void 0;

const JPStandardParser_1 = __importDefault(require("./parsers/JPStandardParser"));

const JPMergeDateRangeRefiner_1 = __importDefault(require("./refiners/JPMergeDateRangeRefiner"));

const JPCasualDateParser_1 = __importDefault(require("./parsers/JPCasualDateParser"));

const chrono_1 = require("../../chrono");

exports.casual = new chrono_1.Chrono(createCasualConfiguration());
exports.strict = new chrono_1.Chrono(createConfiguration());

function parse(text, ref, option) {
  return exports.casual.parse(text, ref, option);
}

exports.parse = parse;

function parseDate(text, ref, option) {
  return exports.casual.parseDate(text, ref, option);
}

exports.parseDate = parseDate;

function createCasualConfiguration() {
  const option = createConfiguration();
  option.parsers.unshift(new JPCasualDateParser_1.default());
  return option;
}

exports.createCasualConfiguration = createCasualConfiguration;

function createConfiguration() {
  return {
    parsers: [new JPStandardParser_1.default()],
    refiners: [new JPMergeDateRangeRefiner_1.default()]
  };
}

exports.createConfiguration = createConfiguration;